import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../login/auth";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <footer className="theme-footer text-center">
        <a
          className="item"
          href="http://imageio.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered By : <span>Control</span>
          <span>A</span>
        </a>
      </footer>
    );
  }
}
function mapStateToProps({ auth }) {
  return { auth };
}
export default connect(
  mapStateToProps,
  actions
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js